(function(){
  function parse(u){
    if (!u) return null;
    var m = u.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
    if (m) return { t: 'yt', id: m[1] };
    m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return { t: 'vm', id: m[1] };
    return null;
  }
  function frame(src, title){
    var f = document.createElement('iframe');
    f.src = src; f.title = title || 'V\u00eddeo';
    f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    f.allowFullscreen = true; f.loading = 'lazy';
    return f;
  }
  function init(el){
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var v = parse(el.dataset.url);
    var th = el.querySelector('[data-yt-thumb]');
    if (th && v && v.t === 'yt') th.src = 'https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg';
    var btn = el.querySelector('.bwv__play');
    if (!btn) return;
    btn.addEventListener('click', function(){
      var title = btn.getAttribute('aria-label');
      var tpl = el.querySelector('template');
      if (tpl) {
        el.appendChild(tpl.content.cloneNode(true));
        var vid = el.querySelector(':scope > video');
        if (vid && vid.play) { var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
      } else if (el.dataset.embed) {
        el.appendChild(frame(el.dataset.embed, title));
      } else if (v) {
        el.appendChild(frame(v.t === 'yt' ? 'https://www.youtube-nocookie.com/embed/' + v.id + '?autoplay=1&rel=0&modestbranding=1' : 'https://player.vimeo.com/video/' + v.id + '?autoplay=1', title));
      } else if (el.dataset.url) {
        window.open(el.dataset.url, '_blank', 'noopener');
        return;
      }
      el.classList.add('is-playing');
      var host = el.closest('[data-bwv-host]');
      if (host) host.classList.add('is-playing');
    });
  }
  window.bwStopVideo = function(el){
    if (!el || !el.classList.contains('is-playing')) return;
    el.querySelectorAll(':scope > iframe, :scope > video').forEach(function(n){ n.remove(); });
    el.classList.remove('is-playing');
    var host = el.closest('[data-bwv-host]');
    if (host) host.classList.remove('is-playing');
  };
  window.bwInitVideos = function(root){ (root || document).querySelectorAll('[data-bwv]').forEach(init); };
  window.bwInitVideos();

  document.querySelectorAll('[data-bwb]').forEach(function(root){
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){
        tabs.forEach(function(o){ o.setAttribute('aria-selected', 'false'); o.tabIndex = -1; var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = true; });
        t.setAttribute('aria-selected', 'true'); t.tabIndex = 0;
        var panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = false;
      });
      t.addEventListener('keydown', function(e){
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); n.click();
      });
    });
  });
})();
